module.exports = __webpack_public_path__ + "img/cabo-verde.66a51943.svg";